import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Image, Input, Modal, Row, Select, Tooltip } from "antd";
import Message from "../common/Message";
import AuthService from "../auth/AuthService";
import config from "../config";
import { PostponeReasons } from "../common/Constants";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import qs from "query-string";
import { useNavigate } from "react-router-dom";



const Auth = new AuthService();

const PostponeModal = ({ isModalOpen, setIsModalOpen, selectedOrder, selectedRoute }) => {
  const { TextArea } = Input;
  const { Option } = Select;
  const navigate = useNavigate()

  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [reason, setReason] = React.useState(null);
  const [notes, setNotes] = React.useState("");
  
  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  


//   const handleOk = () => {
//     setIsModalOpen(false);
//   };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetState()
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${
        file.name.split(".")[1]
      }`;
      setLoadMessage("");
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const getUploadUrl = async (file) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/postpone_order/" + selectedRoute + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const resetState = () => {
    setReason(null);
    setNotes('');
    setFiles([]);
    setCurrentItemFiles([]);
    setDeletedFiles([]);
    setIsLoading(false);
    setLoadMessage("");
    setType("info");
  };

  const handleOk = async () => {
    let rand = Math.random() * 50;
  let str = " ";
  for (let i = 0; i < rand; i++) {
    str += " ";
  }

  if (!reason ) {
    setType("error");
    setLoadMessage(`Please select reason for postponment ${str}`);
    return;
  }

    setIsLoading(true)
    const postponeData = {
      route_status_id: selectedRoute,
      postponed_notes: notes || "",
      delivered: 2,
      internal_id: selectedOrder?.internalId,
      postponed_files: currentItemFiles,
      postponed_status: reason
    };

    try {
      const res = await Auth.fetch("/driverapp/change-order-postponed-status", {
        method: "POST",
        body: JSON.stringify(postponeData),
      });
      if (res?.ack) {
        const uploadPromises = files.map(async (f) => {
          try {
            const uploadUrl = await getUploadUrl(f);
            await uploadFileToS3(uploadUrl, f.file, f.file.type);
          } catch (error) {
            setLoadMessage("Error uploading file:");
            setType("error");
            console.error("Error uploading file:", error);
          }
        });
        Promise.all(uploadPromises).then(() => {
         setIsModalOpen(false);
          navigate("/routes");
          setIsLoading(false);
        });
      } else {
        setLoadMessage(res?.message);
        setType("error")
      }
    } catch (err) {
      console.log('error',err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        width={800}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        title={"Postpone Order"}
        style={{
            top: 20,
        }}
        // cancelButtonProps={{ style: { display: "none" } }}
        confirmLoading={isLoading}
        footer={[
          <Button
          size="large"
          // type="primary"
          // loading={isLoading}
          onClick={handleCancel}
        >
          {'Cancel'}
        </Button>,
            <Button
              type="primary"
              size="large"
              loading={isLoading}
              onClick={handleOk}
            >
              {'Save'}
            </Button>,
          ]}
      >
        <>
          <Row gutter={[16, 4]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
              <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                Reason
                <span style={{ color: "red", fontSize: "20px" }}>*</span>
              </h4>
              <Select
                style={{
                  width: "100%",
                }}
                size="large"
                value={reason}
                placeholder="Select Postpone Reason"
                onChange={(value) => {
                  setReason(value);
                }}
              >
                {PostponeReasons.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.title}
                  </Option>
                ))}
              </Select>
            </Col>
            {/* <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
                Notes
                <span style={{ color: "red", fontSize: "20px" }}>*</span>
              </h4>
              <TextArea
                  autoSize={{ minRows: 3, maxRows: 6 }}
                  label="Notes"
                  placeholder="Enter Any Specific Notes"
                  onChange={(e) => setNotes(e.target.value)}
                  value={notes}
                />
            </Col> */}
          </Row>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>Notes</h4>
      <div style={{ marginBottom: "10px" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <TextArea
              autoSize={{ minRows: 3, maxRows: 6 }}
              label="Notes"
              placeholder="Enter Any Specific Notes"
              onChange={(e) => setNotes(e.target.value)}
              value={notes}
            />
          </Col>
        </Row>
      </div>
          <Divider />
          <div>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            accept="image/*, video/*"
            onChange={(e) => {
              handleSubmitImage(e);
            }}
          />
        </UploadButton>
      </div>
      {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
      <Image.PreviewGroup>
        {currentItemFiles?.length > 0 &&
          currentItemFiles
            .filter((item) => !files.some((file) => file.name === item))
            .map((item) => {
              const imageUrl = `${config.tms_uploads_cdn}/${config.env}/postpone_order/${selectedRoute}/${item}`;
              return (
                <div
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    display: "inline-block",
                  }}
                >
                  <Image
                    width={200}
                    height={150}
                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                    src={imageUrl}
                  />
                  <Tooltip title="Delete">
                    <CloseOutlined
                      style={{
                        fontSize: "30px",
                        position: "absolute",
                        right: 5,
                        top: 5,
                        color: "#c12828",
                      }}
                      onClick={() => handleDeleteCurrentFile(item)}
                    />
                  </Tooltip>
                  
                </div>
              );
            })}
      </Image.PreviewGroup>
        </>
        <Divider />
      {files?.length > 0 && <h4>New Files:</h4>}
      <Image.PreviewGroup>
        {files?.length > 0 &&
          files.map((files) => {
            return (
              <div
                style={{
                  position: "relative",
                  marginRight: "10px",
                  display: "inline-block",
                }}
              >
                <Image
                  width={200}
                  height={150}
                  style={{ padding: "5px", border: "1px solid lightgrey" }}
                  src={URL.createObjectURL(files.file)}
                />
                <Tooltip title="Delete">
                  <CloseOutlined
                    style={{
                      fontSize: "30px",
                      position: "absolute",
                      right: 5,
                      top: 5,
                      color: "#c12828",
                    }}
                    onClick={() => handleDeleteFile(files.name)}
                  />
                </Tooltip>
              </div>
            );
          })}
      </Image.PreviewGroup>
      {files?.length > 0 && <Divider />}
      </Modal>
      <Message type={type} msg={loadMessage} />
    </>
  );
};

export default PostponeModal;
